import type { UserPermission } from '@worldathletics/types';

export const Permission = {
  DocumentsCreate: 'documents:create',
  DocumentsEdit: 'documents:edit',
  DocumentsArchive: 'documents:archive',
  DocumentsDelete: 'documents:delete',
  DocumentsPublish: 'documents:publish',
  DocumentsRestore: 'documents:restore',
  UsersRead: 'users:read',
  UsersManage: 'users:manage',
  ParametersManage: 'parameters:manage',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export const ROLE_PERMISSIONS: Record<UserPermission, Permission[]> = {
  admin: Object.values(Permission) as Permission[],
  editor: [
    Permission.DocumentsCreate,
    Permission.DocumentsEdit,
    Permission.DocumentsArchive,
    Permission.UsersRead,
  ],
  reader: [],
};

export function hasPermission(
  role: UserPermission,
  permission: Permission,
): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
